// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1qwqE","alert":"SettungsInbox_alert__3GNNI"};